import React from 'react';
import Header from '../Components/Header'
import InfoBody from '../Components/InfoBody';


const InfoVisa = () => {
  return (
    <div className='h-screen w-full'>
      <Header />
      <InfoBody />
    </div>
  );
}

export default InfoVisa;